<template>

  
  <div id="contact_form_wrapper">
        
        <div v-if="submitting">
          <div class="col-12">
            <div class="response text-right" v-if="response">
              {{response}}
            </div>
            <div v-else id="submitting"><div class="loader">Loading...</div></div>
          </div>
         
        </div>

        <form v-else id="new_client_form" class="my-5" v-on:submit.prevent="validateForm()">  
            <div class="form-row justify-content-center mx-1">
              <div class="col-md-12">
                <h3 class="text-center my-3">Preferred Client:</h3>
                <hr>
              </div>
            </div>

              <div class="form-row mx-1 mb-3 mt-3">
                
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" v-model="form.lead" id="lead" value="Lead">
                  <label class="form-check-label" for="lead">Lead</label>
                </div>

                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" v-model="form.lead" id="proposal" value="Proposal">
                  <label class="form-check-label" for="proposal">Proposal</label>
                </div>

                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" v-model="form.lead" id="job" value="Job">
                  <label class="form-check-label" for="job">Job</label>
                </div>
              
            
              </div>

            <div class="form-row justify-content-center mx-1">

              <div class="col-md-6" :class="{ 'hasError': $v.form.company.$error }">
                  <input type="text" class="form-control my-2" placeholder="Client or Company" v-model="form.company" >
                  <label class="error small form-text invalid-feedback" v-if="!$v.form.company.required">Company is required</label>
              </div>

               <div class="col-md-6" :class="{ 'hasError': $v.form.name.$error }">
                <input type="text" class="form-control my-2" placeholder="Contact name (if different from Client)" v-model="form.name">
                <label class="error small form-text invalid-feedback" v-if="!$v.form.name.required">Name is required</label>
              </div>

            </div>

            <div class="form-row justify-content-center mx-1">
              
              <div class="col-12 col-md-6" :class="{ 'hasError': $v.form.address.$error }">
                  <input type="text" class="form-control my-2" placeholder="Address" v-model="form.address">
                  <label class="error small form-text invalid-feedback" v-if="!$v.form.address.required">Address is required</label>
              </div>

              <div class="col-12 col-md-6" :class="{ 'hasError': $v.form.cross_street.$error }">
                <input type="text" class="form-control my-2" placeholder="Cross Streets" v-model="form.cross_street">
                <label class="error small form-text invalid-feedback" v-if="!$v.form.cross_street.required">Cross Streets required</label>
              </div>


            </div>
            <div class="form-row justify-content-center mx-1">

                <div class="col-md-4" :class="{ 'hasError': $v.form.city.$error }">
                  <input type="text" class="form-control my-2" placeholder="City" v-model="form.city" >
                  <label class="error small form-text invalid-feedback" v-if="!$v.form.city.required">City is required</label>
                </div>

                <div class="col-md-2" :class="{ 'hasError': $v.form.state.$error }">
                  <select class="form-control my-2" v-model="form.state">
                   
                    <option value="AL">Alabama</option>
                    <option value="AK">Alaska</option>
                    <option value="AZ">Arizona</option>
                    <option value="AR">Arkansas</option>
                    <option value="CA">California</option>
                    <option value="CO">Colorado</option>
                    <option value="CT">Connecticut</option>
                    <option value="DE">Delaware</option>
                    <option value="DC">District Of Columbia</option>
                    <option value="FL">Florida</option>
                    <option value="GA">Georgia</option>
                    <option value="HI">Hawaii</option>
                    <option value="ID">Idaho</option>
                    <option value="IL">Illinois</option>
                    <option value="IN">Indiana</option>
                    <option value="IA">Iowa</option>
                    <option value="KS">Kansas</option>
                    <option value="KY">Kentucky</option>
                    <option value="LA">Louisiana</option>
                    <option value="ME">Maine</option>
                    <option value="MD">Maryland</option>
                    <option value="MA">Massachusetts</option>
                    <option value="MI">Michigan</option>
                    <option value="MN">Minnesota</option>
                    <option value="MS">Mississippi</option>
                    <option value="MO">Missouri</option>
                    <option value="MT">Montana</option>
                    <option value="NE">Nebraska</option>
                    <option value="NV">Nevada</option>
                    <option value="NH">New Hampshire</option>
                    <option value="NJ">New Jersey</option>
                    <option value="NM">New Mexico</option>
                    <option value="NY">New York</option>
                    <option value="NC">North Carolina</option>
                    <option value="ND">North Dakota</option>
                    <option value="OH">Ohio</option>
                    <option value="OK">Oklahoma</option>
                    <option value="OR">Oregon</option>
                    <option value="PA">Pennsylvania</option>
                    <option value="RI">Rhode Island</option>
                    <option value="SC">South Carolina</option>
                    <option value="SD">South Dakota</option>
                    <option value="TN">Tennessee</option>
                    <option value="TX">Texas</option>
                    <option value="UT">Utah</option>
                    <option value="VT">Vermont</option>
                    <option value="VA">Virginia</option>
                    <option value="WA">Washington</option>
                    <option value="WV">West Virginia</option>
                    <option value="WI">Wisconsin</option>
                    <option value="WY">Wyoming</option>


                  </select>
                  <label class="error small form-text invalid-feedback" v-if="!$v.form.state.required">State is required</label>
                </div>

                <div class="col-md-2" :class="{ 'hasError': $v.form.zip.$error }">
                  <input type="text" class="form-control my-2" placeholder="Zip code" v-model="form.zip" >
                  <label class="error small form-text invalid-feedback" v-if="!$v.form.zip.required">Zip is required</label>
                </div>

                <div class="col-md-4" :class="{ 'hasError': $v.form.phone.$error }">
                  <input type="text" class="form-control my-2" placeholder="Main Phone Number" v-model="form.phone" >
                  <label class="error small form-text invalid-feedback" v-if="!$v.form.phone.required">Phone is required</label>
                </div>

            </div>

            <div class="form-row justify-content-center mx-1">


               <div class="col-md-4" :class="{ 'hasError': $v.form.hear.$error }">
                <input type="text" class="form-control my-2" placeholder="How did they hear about us?" v-model="form.hear" >
                <label class="error small form-text invalid-feedback" v-if="!$v.form.hear.required">Field required</label>
              </div>

             
             

              <div class="col-md-4" :class="{ 'hasError': $v.form.mobile.$error }">
                  <input type="text" class="form-control my-2" placeholder="Contact Mobile (for appt reminders)" v-model="form.mobile" >
                  <label class="error small form-text invalid-feedback" v-if="!$v.form.mobile.required">Mobile is required</label>
              </div>

              <div class="col-md-4" :class="{ 'hasError': $v.form.email.$error }">
                  <input type="text" class="form-control my-2" placeholder="Contact Email" v-model="form.email" >
                  <label class="error small form-text invalid-feedback" v-if="!$v.form.email.required">Email is required</label>
                  <label class="error small form-text invalid-feedback" v-if="!$v.form.email.email">Please use a valid email</label>

              </div>

             


            </div>


            
            <div class="form-row justify-content-center mx-1 mt-5">
              <div class="col-md-12">
                <hr>
                <h3 class="text-center my-3">Treatment Location{{form.locations.length>1 ? 's':''}}:</h3>
                <hr>
              </div>

              <!-- <div class="col-md-12 mb-2">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="same_address" v-model="form.same_location">
                  <label class="form-check-label" for="same_address">Same as above</label>
                </div>
              </div> -->


            </div>


            <!-- locations here -->
            <div v-if="!form.same_location">
            <location-component v-for="(location,index) in form.locations" :key="index" 
            ref="locations"
            :index="index" 
            :mainForm="form"
            :location="location" 
             @form_changed="form_changed"
             @remove_location="remove_location"
            />

            <div class="col-12 mt-3 text-center">
              <button class="add_location" type="button" @click="add_location()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle align-middle mr-2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
                <span class="align-middle">ADD LOCATION</span>
                </button>
            </div>
            </div>
            <!-- locattions here -->


            

            <div class="form-row mx-1 mt-5">
              <div class="col-md-6" :class="{ 'hasError': $v.form.salesperson.$error }">
                <input type="text" class="form-control my-2" placeholder="Email of Salesperson" v-model="form.salesperson" >
                <label class="error small form-text invalid-feedback" v-if="!$v.form.salesperson.required">Email of Salesperson required</label>
                <label class="error small form-text invalid-feedback" v-if="!$v.form.salesperson.email">Please use a valid email</label>
              </div>
            </div>

            <div class="form-row mx-1 mt-1">
              <div class="col-md-12" >

                <label class="mb-0" for="notes">Notes</label>
                <textarea class="form-control" id="notes" rows="3" v-model="form.notes"></textarea>
             
              </div>
            </div>


            <div class="form-row justify-content-center mx-1 my-5">
              <div class="col-12 text-center text-md-right order-1 order-md-2">
              <hr>
                  <button type="button" class="btn btn-custom mr-0" @click="validateForm()"> 
                    <span class="align-middle mr-2">Submit</span> 
                    <svg xmlns="http://www.w3.org/2000/svg" width="28.837" height="28.837" viewBox="0 0 28.837 28.837"><g transform="translate(-241.544 -258.377)"><path d="M251.931,279.378l9.311-6.72-9.311-6.719-.813,1.128,7.75,5.591-7.75,5.592Z" transform="translate(0.172 0.136)" fill="#004093"/><path d="M255.963,287.214a14.418,14.418,0,1,0-14.419-14.419h0A14.435,14.435,0,0,0,255.963,287.214Zm0-27.447A13.029,13.029,0,1,1,242.934,272.8h0A13.043,13.043,0,0,1,255.963,259.767Z" transform="translate(0 0)" fill="#004093"/></g></svg></button>
                </div>
            </div>
          </form>
  </div>  

</template>

<script>
  import clientForm from './clientForm'
  export default clientForm
</script>

<style lang="css" scoped>

.add_location{
  border: none;
  background: #005cb9;
  color: #fff;
  padding: 10px 20px;
}

.hasError .invalid-feedback{
display: block !important;
color: red;
}

.response{
  font-family: bree,sans-serif;
  font-weight: 600;
  font-style: italic;
  font-size: 18px;
  line-height: 18px;
}




</style>

